<template>
  <div class="transactions">
    <h2 class="mb-2 primary--text">TRANSACTIONS</h2>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="transactionsList"
          item-key="TransactionId"
          :items-per-page="-1"
          :loading="loading"
          loading-text="Loading transactions list..."
          :calculate-widths="true"
          class="searchResults"
          dense
        >
          <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item, value }">
            {{ formatTableEl(item, value, header.format) }}
          </template>
          <template v-slot:[`item.InvestDate`]="{ item }">
            <span>{{ displayDate(new Date(item.InvestDate)) }}</span>
          </template>
          <template v-slot:[`item.PayDate`]="{ item }">
            <span>{{ displayDate(new Date(item.PayDate)) }}</span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Utils from '@/utils.js';

export default {
  components: {},
  name: 'Transactions',

  data() {
    return {
      loading: false,
      headers: [
        { text: 'InvestDate', value: 'InvestDate' },
        { text: 'Status', value: 'Status' },
        { text: 'ManagerName', value: 'ManagerName' },
        { text: 'FundName Type', value: 'FundName' },
        { text: 'ContributionType', value: 'ContributionType' },
        { text: 'Description', value: 'Description' },
        { text: 'Units', value: 'Units' },
        { text: 'Value', value: 'Value' },
        { text: 'Contributions', value: 'Contributions' },
        { text: 'Percentage', value: 'Percentage' },
        { text: 'Charge', value: 'Charge' },
        { text: 'ExchangeRate', value: 'ExchangeRate' },
        { text: 'PayDate', value: 'PayDate' },
        { text: 'TransactType', value: 'TransactType' },
        { text: 'UnitPrice', value: 'UnitPrice' },
      ],
      transactionsList: [],
    };
  },

  computed: {
    memberId() {
      return this.$store.state.selectedMemberId;
    },
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },

  watch: {
    memberId() {
      this.getTransactionsList();
    },
  },

  created() {
    this.getHeaders('Transactions');
  },

  mounted: function () {
    if (!this.memberId) {
      this.$store.commit('setNotificationMessage', {
        type: 'info',
        text: 'Please, select member',
      });
      this.$router.push({ path: '/' });
    } else {
      this.getTransactionsList();
      this.$root.currentPage = 'Investments';
    }
  },

  destroyed() {
    this.$root.currentPage = null;
  },

  methods: {
    displayDate(date) {
      if (date.getFullYear() <= 1900) return null;
      return Utils.getDateStr(date);
    },
    formatTableEl(item, value, format) {
      return Utils.formatTableValue(value, format);
    },
    async getTransactionsList() {
      this.loading = true;
      try {
        let response = await this.$api.get(
          '/Transactions/GetTransactionList?membershipId=' + this.memberId
        );
        this.transactionsList = response.data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
    async getHeaders(formName) {
      try {
        const response = await this.$api.get(
          `/datadictionary/GetGridHeaders?formName=${formName}&planId=${this.currentPlanId}`
        );
        if (response.data.length) {
          const data = response.data.filter((item) => item.Visible);
          data.sort((a, b) => a.ColumbOrder - b.ColumbOrder);
          this.headers = data.map((item) => ({
            text: item.HeaderText,
            value: item.Datafield,
            align: item.Align.toLowerCase(),
            format: item.FieldFormat,
          }));
        }
      } catch (err) {
        console.log(err.message);
      }
    },
  },
};
</script>

<style lang="scss">
.transactions {
  margin-top: 5px;
  margin-bottom: 10px;
  padding: 5px 30px;

  .v-data-table tbody tr {
    cursor: default;
  }
}
</style>
